import { useFormik } from "formik";
import { useCallback, useEffect, useMemo, useState } from "react";
import * as Yup from "yup";
import clsx from "clsx";
import { useLocation, useNavigate } from "react-router-dom";
import { Modal } from "react-bootstrap";
import toast from "react-hot-toast";
import ReactSelect from "react-select";
import Styles from "./CheckOut.module.css";
import next from "../../../Assets/next.png";
import save from "../../../Assets/bookmark_white.png";
import nextWhite from "../../../Assets/next_white.png";
import cancel from "../../../Assets/cross.png";
import bookPrimary from "../../../Assets/book_primary.png";
import editLocationIcon from "../../../Assets/edit_location_primary.png";
import cancelIcon from "../../../Assets/cancel_primary.png";
import {
  cityService,
  emiProviderService,
  getAutoGeneratedInvoiceNumberService,
  getEtaDetailsService,
  getPermissionSettingsService,
  stateService,
  viewProfileService,
} from "../../../Services/ApiServices";
import Header from "../../../SharedComponents/Header/Header";
import Loader from "../../../SharedComponents/Loader/Loader";
import {
  ADDRESS_ID_PRE_TEXT,
  BILLING_ADDRESS_LIST_KEY,
  DEFAULT_LOCATION,
  getCookie,
  phoneExp,
  SAVE_ADDRESS_LIST,
  SHIPPING_ADDRESS_LIST_KEY,
} from "../../../Utility/Utility";
import { useSelector } from "react-redux";
import OrderType from "../../../SharedComponents/OrderType/OrderType";
// import LocationInput from "../../../SharedComponents/LocationInput/LocationInput";
import AddressListModal from "../../../Modal/AddressListModal";
import MapContainerLeaflet from "../../../SharedComponents/MapContainer/MapContainerLeaflet";
import MapContainer from "../../../SharedComponents/MapContainer/MapContainer";
import LocationInput from "../../../SharedComponents/LocationInput/LocationInput";
import { DELIVERY_TYPE } from "../../../Utility/enums.ts";

let EMAIL_REGEX = new RegExp(
  /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
);
const PINCODE_REGEX = /^[1-9][0-9]{5}$/;

const getShopDeliveryType = () => {
  try {
    const shopScrollers = JSON.parse(sessionStorage.getItem("shop_scrollers"));
    return shopScrollers?.delivery_type
      ? parseInt(shopScrollers?.delivery_type)
      : null;
  } catch (e) {
    return null;
  }
};

export default function Checkout() {
  let { state, pathname } = useLocation();
  let navigate = useNavigate();
  let isDisabled = state?.status === 2;
  const [isShowShipping, setIsShowShipping] = useState(false);
  const [isNeedCustomerUrl, setIsNeedCustomerUrl] = useState(false);
  const [states, setStates] = useState([]);
  const [billingCitiesList, setbillingCitiesList] = useState([]);
  const [shippingCitiesList, setshippingCitiesList] = useState([]);
  const [city, setCity] = useState([]);

  const [loader, setLoader] = useState(false);
  const [billOptions, setBillOption] = useState(1);
  const [selectRef, setSelectRef] = useState({ state: "", city: "" });
  const [showModal, setShowModal] = useState(false);
  const [emiProviders, setEmiProviders] = useState([]);
  const [paymentLinkError, setPaymentLinkError] = useState(false);
  const [franchiseLocation, setfranchiseLocation] = useState(null);
  const [addressListPopupData, setaddressListPopupData] = useState({
    status: false,
    isSave: false,
    isBilling: false,
  });
  const [savedBillingAddressList, setsavedBillingAddressList] = useState([]);
  const [savedShippingAddressList, setsavedShippingAddressList] = useState([]);
  const [isEditDeliveryLocationMap, setisEditDeliveryLocationMap] =
    useState(false);

  const [isEnabledAutoInvoice, setisEnabledAutoInvoice] = useState(false);
  const [shopDeliveryType] = useState(getShopDeliveryType());

  useEffect(() => {
    getPermissiosApiCall();
    stateService()
      .then((res) => setStates(res.data))
      .catch((err) => {});
    if (state?.status !== 2) {
      handleUserData();
    }
  }, []);

  useEffect(() => {
    if (state === null) {
      navigate("/store");
    }
    if (state?.status === 2 && !pathname.includes("/kansas_product")) {
      handleConfirmation();
    }
    handleEmiProviders();
  }, []);

  const handleEmiProviders = () => {
    emiProviderService()
      .then((res) => {
        setEmiProviders(res.data);
      })
      .catch((err) => {
        if (err?.response?.data?.detail) {
          toast(err.response.data.detail[0].msg, { type: "error" });
        } else {
          toast("Something went wrong!!");
        }
      });
  };

  useEffect(() => {
    if (billOptions === 1 && !pathname.includes("/kansas_product")) {
      handleSetCustomerDetails();
    }
  }, []);

  useEffect(() => {
    if (state?.fromCustomerWishlist) {
      handleCustomerWishlistData();
    }
  }, []);

  useEffect(() => {
    let userData = JSON.parse(sessionStorage.getItem("custmerDetails"));
    if (userData === null && !pathname.includes("/kansas_product")) {
      handleCustomerData();
    }
  }, []);

  useEffect(() => {
    if (pathname.includes("/store")) {
      getProfileApiCall();
    }
  }, []);

  const handleCustomerWishlistData = () => {
    setValues({
      ...values,
      billingName: state?.CustomerDetails?.customer_name,
      billingEmail: state?.CustomerDetails?.email,
      billingAddress: state?.CustomerDetails?.address,
      billingCity: state?.CustomerDetails?.city,
      billingState: state?.CustomerDetails?.state,
      billingMobile: state?.CustomerDetails?.mobile_no,
      billingPincode: state?.CustomerDetails?.pincode,
    });
    handleCity(state?.CustomerDetails?.state, true);
  };

  const handleCustomerData = () => {
    let customerLoginDetail = JSON.parse(sessionStorage.getItem("customerlog"));
    if (customerLoginDetail !== null) {
      setValues({
        ...values,
        billingName: customerLoginDetail.name,
        billingEmail: customerLoginDetail.email,
        billingMobile: customerLoginDetail.mblNumber,
        billingAddress: customerLoginDetail.address,
        billingCity: "",
        billingState: "",
        billingPincode: "",
        shippingName: "",
        shippingMobile: "",
        shippingState: "",
        shippingCity: "",
        shippingAddress: "",
        shippingEmail: "",
        shippingPincode: "",
      });
    }
  };

  const handleUserData = () => {
    // let userData = JSON.parse(sessionStorage.getItem("custmerDetails"));
    let storeData = JSON.parse(sessionStorage.getItem("storeDetails"));
    // if (userData !== null && pathname.includes("/kansas_product")) {
    //   setValues({
    //     ...values,
    //     ...userData,
    //   });
    //   handleCity(userData.billingState, true);
    // }
    if (
      storeData !== null &&
      state.status !== 2 &&
      !pathname.includes("/kansas_product")
    ) {
      setValues({
        ...values,
        ...storeData,
      });
      handleCity(storeData.billingState, true);
    }
  };

  const handleSetCustomerDetails = () => {
    let forCustomerDetails = JSON.parse(
      sessionStorage.getItem("forCustomerDetails"),
    );
    if (forCustomerDetails !== null && billOptions === 1) {
      setValues({ ...values, ...forCustomerDetails });
      handleCity(forCustomerDetails.billingState, true);
    }
  };

  const {
    handleChange,
    setValues,
    handleSubmit,
    errors,
    values,
    setFieldValue,
    touched,
    resetForm,
    validateForm,
  } = useFormik({
    initialValues: {
      billingMobile: "",
      billingState: "",
      billingCity: "",
      billingPincode: "",
      billingName: "",
      billingEmail: "",
      billingAddress: "",
      shippingName: "",
      shippingAddress: "",
      shippingMobile: "",
      shippingPincode: "",
      shippingState: "",
      shippingCity: "",
      state_name: "",
      city_name: "",
      shipping_statename: "",
      shipping_cityname: "",
      shippingEmail: "",
      paymentStatus: 3,
      emiOption: "",
      posMachine: "",
      emiProvidername: "",
      paymentLinkNo: "",
      gst_no: "",
      invoice_no: "",
      customer_name: "",
      customer_mobile: "",
      OtherEmiOption: "",
      DealerCode: "",
      id: -1,
      delivery_charge: "",
      selectedDeliveryType: pathname.includes("/kansas_product")
        ? shopDeliveryType === DELIVERY_TYPE.Customer_Pickup
          ? 2
          : 1
        : (state?.CustomerDetails?.delivery_type ?? undefined), // 1-Home Delivery - Delivery Partner,2-Takeaway, 3- Delivery by store
      deliveryGeo: null,
    },
    validationSchema: Yup.object({
      billingMobile: Yup.string()
        .min(10, "Mobile number must 10 character")
        .matches(phoneExp, "Mobile number must start with 9 or 8 or 7 or 6 ")
        .required("Required"),
      billingState: Yup.string().required("Required"),
      billingCity: Yup.string().required("Required"),
      billingPincode: Yup.string()
        .matches(PINCODE_REGEX, "Enter Valid Pincode")
        .required("Required"),
      billingName: Yup.string().required("Required"),
      billingAddress: Yup.string().required("Required"),
      billingEmail: Yup.string().matches(
        EMAIL_REGEX,
        "Enter Valid email Address",
      ),
      // .required("Required"),
      gst_no: Yup.string().matches(
        /^[a-zA-Z0-9]{15}$/,
        "Enter Valid GST Number",
      ),
      paymentLinkNo: Yup.string().matches(
        phoneExp,
        "Enter a valid Mobile number",
      ),
      invoice_no:
        state?.status === 1 ? Yup.string().required("Required") : Yup.string(),
      DealerCode: Yup.string().when("id", {
        is: (id) => id === 15280 || id === 16641 || id === 14936,
        then: (schema) => schema.required("Dealer Code is required"),
        otherwise: (schema) => schema.notRequired(),
      }),

      customer_mobile: Yup.string().matches(
        phoneExp,
        "Mobile number must start with 9 or 8 or 7 or 6 ",
      ),
      selectedDeliveryType: Yup.number().required("Delivery type is required"),

      deliveryGeo: Yup.object()
        .nullable()
        .test("delivery-required-based-on-route", "Required", function (value) {
          const { selectedDeliveryType } = this.parent;

          if (
            selectedDeliveryType === 1 &&
            pathname.includes("/kansas_product")
          ) {
            return !!value;
          }

          return true;
        }),
    }),
    validate: () => {
      let err = {};
      if (isShowShipping) {
        if (values.shippingName === "") {
          err.shippingName = "Required";
        }
        if (values.shippingAddress === "") {
          err.shippingAddress = "Required";
        }
        if (!phoneExp.test(values.shippingMobile)) {
          err.shippingMobile = "Mobile number must start with 9 or 8 or 7 or 6";
        }
        if (values?.shippingMobile && values?.shippingMobile.length < 9) {
          err.shippingMobile = "Enter a valid Mobile number";
        }
        if (values.shippingMobile === "") {
          err.shippingMobile = "Required";
        }
        if (values.shippingPincode === "") {
          err.shippingPincode = "Required";
        }
        if (
          values.shippingPincode !== "" &&
          !PINCODE_REGEX.test(values.shippingPincode)
        ) {
          err.shippingPincode = "Enter Valid Pincode";
        }
        if (values.shippingState === "") {
          err.shippingState = "Required";
        }
        if (values.shippingCity === "") {
          err.shippingCity = "Required";
        }
        // if (values.shippingEmail === "") {
        //   err.shippingEmail = "Required";
        // }
        if (values.shippingEmail && !EMAIL_REGEX.test(values.shippingEmail)) {
          err.shippingEmail = "Enter valid email address";
        }
        if (billOptions === 1 && values.paymentStatus === "") {
          err.paymentStatus = "Required";
        }
      }
      if (isShowShipping || !isShowShipping) {
        if (values.paymentStatus === 4 && values.emiOption === "") {
          err.emiOption = "Required";
        }
        if (values.paymentStatus === 10 && values.posMachine === "") {
          err.posMachine = "Required";
        }
        if (
          values.paymentStatus === 4 &&
          values.emiOption == 4 &&
          values.OtherEmiOption === ""
        ) {
          err.OtherEmiOption = "Required";
        }
        if (values.paymentStatus === 6 && values.paymentLinkNo === "") {
          err.paymentLinkNo = "Required";
        }
        if (
          values.paymentStatus === 8 &&
          isNeedCustomerUrl &&
          values.customer_name === ""
        ) {
          err.customer_name = "Required";
        }
        if (
          values.paymentStatus === 8 &&
          isNeedCustomerUrl &&
          values.customer_mobile === ""
        ) {
          err.customer_mobile = "Required";
        }
      }

      return err;
    },
    onSubmit: (values) => {
      handleCheckout(values);
      if (billOptions === 1) {
        handleCustomerDetails(values);
      }
      setLoader(true);
    },
  });

  useEffect(() => {
    if (pathname.includes("/kansas_product")) {
      handleLoadDefaultValues();
    }
  }, []);

  useEffect(() => {
    const data = sessionStorage.getItem("iddetails");
    const parsedData = data ? JSON.parse(data) : null;
    setFieldValue("id", parsedData?.id); // 👉 14936 will be set
  }, []);

  useEffect(() => {
    if (pathname.includes("/store")) {
      if (
        values.selectedDeliveryType === 1 &&
        state?.CustomerDetails.pincode &&
        state?.CustomerDetails?.latitude &&
        state?.CustomerDetails?.longitude
      ) {
        getEstimatedCourierAmount();
      } else {
        setFieldValue("delivery_charge", "");
      }
    }
  }, [pathname, values.selectedDeliveryType]);

  const getPermissiosApiCall = () => {
    getPermissionSettingsService()
      .then((res) => {
        if (res?.data?.settings?.is_enabled === 1) {
          setisEnabledAutoInvoice(true);
          getInvoiceNumberApiCall();
        } else {
          setisEnabledAutoInvoice(false);
        }
      })
      .catch((err) => {});
  };

  const getInvoiceNumberApiCall = () => {
    getAutoGeneratedInvoiceNumberService()
      .then((res) => {
        if (res.status === 2) {
          setisEnabledAutoInvoice(false);
        } else {
          // Invoice Number Generated
          setFieldValue("invoice_no", res.data.invoice_no);
        }
      })
      .catch((e) => {})
      .finally(() => {});
  };

  const handleCustomerDetails = (data) => {
    const deliveryCharge = data.delivery_charge;
    sessionStorage.setItem(
      "forCustomerDetails",
      JSON.stringify({ ...data, delivery_charge: deliveryCharge }),
    );
  };
  const handleCity = (data, isBilling) => {
    let formData = new FormData();
    formData.append("state_id", parseInt(data));
    cityService(formData)
      .then((res) => {
        if (isBilling) {
          setbillingCitiesList(res.data);
        } else {
          setshippingCitiesList(res.data);
        }
      })
      .catch((err) => {});
  };

  const customStyles = {
    control: (provided, state) => ({
      // none of react-select's styles are passed to <Control />
      backgroundColor: state.isDisabled ? "#f5f5f5" : "white",
      border: "1px solid rgba(0,0,0,0.1)",
      borderRadius: "6px",
      width: "100%",
      padding: "10px 0",
      cursor: state.isDisabled ? "not-allowed" : "default",
      ":hover": {
        borderColor: "none",
      },
    }),
    indicatorsContainer: () => ({
      display: "none",
    }),
    singleValue: (provided, state) => ({
      ...provided,
      color: state.isDisabled ? "#6c757d" : "black",
      fontSize: "15px",
    }),
    input: (provided, state) => ({
      ...provided,
      color: state.isDisabled ? "#6c757d" : "black",
      fontSize: "15px",
    }),
    placeholder: (provided, state) => ({
      ...provided,
      fontSize: "15px",
      color: state.isDisabled ? "#adb5bd" : "#999",
    }),
  };

  const getEstimatedCourierAmount = () => {
    setLoader(true);
    let loginData = getCookie("userlog");
    if (loginData) {
      loginData = JSON.parse(loginData);
    }

    const formData = new FormData();
    formData.append("merchent_id", loginData.user_id);
    formData.append("delivery_pin_code", state?.CustomerDetails.pincode);
    formData.append("delivery_latitude", state?.CustomerDetails?.latitude);
    formData.append("delivery_longitude", state?.CustomerDetails?.longitude);
    // formData.append("delivery_latitude", DEFAULT_LOCATION.lat);
    // formData.append("delivery_longitude", DEFAULT_LOCATION.lng);

    getEtaDetailsService(formData)
      .then((res) => {
        if (res.data?.data?.estimate_price) {
          setFieldValue("delivery_charge", res.data.data.estimate_price);
        }
      })
      .catch((err) => {
        setFieldValue("selectedDeliveryType", 3);
        if (err?.response?.data?.detail) {
          if (err.response.data.detail[0].msg?.includes("Distance too long")) {
            toast(
              "No delivery partners available in your area at the moment.",
              { type: "error" },
            );
          } else {
            toast(err.response.data.detail[0].msg, { type: "error" });
          }
        } else {
          toast("Something went wrong!!");
        }
      })
      .finally(() => {
        setLoader(false);
      });
  };

  const handleLoadDefaultValues = () => {
    if (!pathname.includes("/kansas_product")) return;
    let isFirstAsDefaultBilling = false;
    const submitedValuesStr = sessionStorage.getItem("custmerDetails");

    if (submitedValuesStr) {
      const parsedVals = JSON.parse(submitedValuesStr);
      setValues({
        ...values,
        ...parsedVals,
      });
      setIsShowShipping(parsedVals.isShowShipping);
      handleCity(parsedVals.billingState, true);
      if (parsedVals.isShowShipping || parsedVals.shippingState) {
        handleCity(parsedVals.shippingState, false);
      }
    } else {
      isFirstAsDefaultBilling = true;
    }

    handleRetrieveSavedAddresses(true, isFirstAsDefaultBilling);
    handleRetrieveSavedAddresses(false);
  };

  const handleRetrieveSavedAddresses = (isBilling, isLoadDefault) => {
    if (pathname.includes("/kansas_product")) {
      const str = localStorage.getItem(
        isBilling ? BILLING_ADDRESS_LIST_KEY : SHIPPING_ADDRESS_LIST_KEY,
      );

      const parsedVal = str ? JSON.parse(str) : [];
      {
        if (isBilling) {
          setsavedBillingAddressList(parsedVal);
          if (isLoadDefault) {
            handleSelectAddress(true, parsedVal[0]);
          }
        } else {
          setsavedShippingAddressList(parsedVal);
        }
      }
    }
  };

  const handleSelectAddress = (isBilling, addr) => {
    if (!addr) return;
    let selectedAddr = {};
    if (isBilling) {
      selectedAddr = {
        billingName: addr.billingName,
        billingMobile: addr.billingMobile,
        billingAddress: addr.billingAddress,
        billingState: addr.billingState,
        state_name: addr.state_name,
        billingCity: addr.billingCity,
        city_name: addr.city_name,
        billingPincode: addr.billingPincode,
        billingEmail: addr.billingEmail ? addr.billingEmail : "",
        deliveryGeo: addr.deliveryGeo,
        gst_no: addr.gst_no,
      };
      handleCity(addr.billingState, true);
    } else {
      selectedAddr = {
        shippingName: addr.shippingName,
        shippingMobile: addr.shippingMobile,
        shippingAddress: addr.shippingAddress,
        shippingState: addr.shippingState,
        shipping_statename: addr.shipping_statename,
        shippingCity: addr.shippingCity,
        shipping_cityname: addr.shipping_cityname,
        shippingPincode: addr.shippingPincode,
        shippingEmail: addr.shippingEmail ? addr.shippingEmail : "",
      };
      handleCity(addr.shippingState, false);
    }
    setValues((preValues) => ({ ...preValues, ...selectedAddr }));
  };

  const handleSaveUpdateAddress = (isBilling, updateId) => {
    if (pathname.includes("/kansas_product")) {
      if (isBilling) {
        if (
          savedBillingAddressList.length < 3 ||
          (savedBillingAddressList.length === 3 && updateId)
        ) {
          const currentAddr = {
            id: updateId
              ? updateId
              : ADDRESS_ID_PRE_TEXT + (savedBillingAddressList.length + 1),
            billingName: values.billingName,
            billingMobile: values.billingMobile,
            billingAddress: values.billingAddress,
            billingState: values.billingState,
            state_name: values.state_name,
            billingCity: values.billingCity,
            city_name: values.city_name,
            billingPincode: values.billingPincode,
            billingEmail: values.billingEmail,
            deliveryGeo: values.deliveryGeo,
            gst_no: values.gst_no,
          };
          setsavedBillingAddressList((preList) => {
            let updatedList = [...preList];
            if (updateId) {
              let ind = updatedList.findIndex((item) => item.id === updateId);
              if (ind > -1) {
                updatedList[ind] = { ...currentAddr };
              }
            } else {
              updatedList = [...updatedList, currentAddr];
            }
            localStorage.setItem(
              BILLING_ADDRESS_LIST_KEY,
              JSON.stringify(updatedList),
            );
            toast(
              `Billing address ${updateId ? "updated" : "saved"} successfully.`,
              { type: "success" },
            );
            return [...updatedList];
          });
        } else {
          toast("You can only save up to 3 billing addresses.", {
            type: "error",
          });
        }
      } else {
        if (savedShippingAddressList.length < 3) {
          const currentAddr = {
            id: updateId
              ? updateId
              : ADDRESS_ID_PRE_TEXT + savedShippingAddressList.length + 1,
            shippingName: values.shippingName,
            shippingMobile: values.shippingMobile,
            shippingAddress: values.shippingAddress,
            shippingState: values.shippingState,
            shipping_statename: values.shipping_statename,
            shippingCity: values.shippingCity,
            shipping_cityname: values.shipping_cityname,
            shippingPincode: values.shippingPincode,
            shippingEmail: values.shippingEmail,
          };
          setsavedShippingAddressList((preList) => {
            let updatedList = [...preList];
            if (updateId) {
              let ind = updatedList.findIndex((item) => item.id === updateId);
              if (ind > -1) {
                updatedList[ind] = { ...currentAddr };
              }
            } else {
              updatedList = [...updatedList, currentAddr];
            }
            localStorage.setItem(
              SHIPPING_ADDRESS_LIST_KEY,
              JSON.stringify(updatedList),
            );
            toast(
              `Shipping address ${updateId ? "updated" : "saved"} successfully.`,
              { type: "success" },
            );
            return [...updatedList];
          });
        } else {
          toast("You can only save up to 3 shipping addresses.", {
            type: "error",
          });
        }
      }
    }
  };

  const getSavedAddressesList = useCallback(
    (isBilling) => {
      if (isBilling) {
        return [...savedBillingAddressList];
      }
      return [...savedShippingAddressList];
    },
    [savedBillingAddressList, savedShippingAddressList],
  );

  const isErrorInAddress = (isBilling) => {
    if (isBilling) {
      return !!(
        !values.billingName ||
        !values.billingMobile ||
        !phoneExp.test(values.billingMobile) ||
        !values.billingAddress ||
        !values.billingCity ||
        !values.billingState ||
        !values.billingPincode ||
        (values.selectedDeliveryType === 1 &&
          pathname.includes("/kansas_product") &&
          !values.deliveryGeo) ||
        !PINCODE_REGEX.test(values.billingPincode) ||
        (values.billingEmail && !EMAIL_REGEX.test(values.billingEmail)) ||
        (values.gst_no && !/^[a-zA-Z0-9]{15}$/.test(values.gst_no))
      );
    }

    return !!(
      !values.shippingName ||
      !values.shippingMobile ||
      !phoneExp.test(values.shippingMobile) ||
      !values.shippingAddress ||
      !values.shippingCity ||
      !values.shippingState ||
      !values.shippingPincode ||
      !PINCODE_REGEX.test(values.shippingPincode) ||
      (values.shippingEmail && !EMAIL_REGEX.test(values.shippingEmail))
    );
  };

  const getLocation = () => {
    return new Promise((resolve, reject) => {
      if (values.selectedDeliveryType === 1) {
        resolve({
          lat: values.deliveryGeo?.lat,
          lng: values.deliveryGeo?.lng,
          // lat: DEFAULT_LOCATION.lat,
          // lng: DEFAULT_LOCATION.lng,
        });
      } else {
        navigator.geolocation.getCurrentPosition(
          (position) => {
            resolve({
              lat: position.coords.latitude,
              lng: position.coords.longitude,
              // lat: DEFAULT_LOCATION.lat,
              // lng: DEFAULT_LOCATION.lng,
            });
          },
          (error) => {
            toast(error.message, { type: "error" });
          },
        );
      }
    });
  };

  const handleCheckout = (data) => {
    let product = state?.items;
    product = product.map((ele) => ({
      ...ele,
      franchiseTotalAmount:
        parseInt(ele.qty) *
        parseInt(
          ele?.selectedUnit ? ele?.selectedUnit?.price : ele.franchise_price,
        ),
    }));
    if (pathname.includes("/kansas_product")) {
      getLocation().then((res) => {
        sessionStorage.setItem(
          "location_details",
          JSON.stringify({
            lat: res.lat,
            lng: res.lng,
          }),
        );
        navigate("/kansas_product/invoice", {
          state: {
            productDetails: state,
            billing_details: data,
            shipping_status: isShowShipping,
            id: data?.id,
            dealercode: data?.DealerCode,
            lat: res.lat,
            lng: res.lng,
            deliveryType: data.selectedDeliveryType,
          },
        });
        sessionStorage.setItem(
          "custmerDetails",
          JSON.stringify({ ...data, isShowShipping }),
        );
      });
    } else {
      const deliveryCharge = data.delivery_charge;
      navigate("/store/invoice", {
        state: {
          billing_details: {
            ...data,
            delivery_charge: deliveryCharge,
          },
          wishlist_id: state?.CustomerDetails?.customer_wishlist_id,
          productDetails: { ...state, items: product },
          frombill: billOptions === 2 ? true : false,
          status: state?.status,
          shipping_status: isShowShipping,
          order_from: state?.order_from,
          send_sms: isNeedCustomerUrl,
          id: data?.id,
          dealercode: data?.DealerCode,
          lat: state?.CustomerDetails?.latitude ?? franchiseLocation?.lat,
          lng: state?.CustomerDetails?.longitude ?? franchiseLocation?.lng,
          // lat: DEFAULT_LOCATION.lat,
          // lng: DEFAULT_LOCATION.lng,
          deliveryType: data.selectedDeliveryType,
        },
      });
      sessionStorage.setItem(
        "storeDetails",
        JSON.stringify({ ...data, delivery_charge: deliveryCharge }),
      );
    }
  };

  const handleConfirmation = () => {
    setLoader(true);
    viewProfileService()
      .then(({ data }) => {
        handleCity(data?.state, true);
        setValues({
          ...values,
          billingName: data.user_name,
          billingAddress: data.address,
          billingMobile: data.mobile_no,
          billingState: data.state,
          billingCity: data.city,
          billingPincode: data.pincode,
          state_name: data.state_name,
          city_name: data.city_name,
          billingEmail: data.email,
        });
      })
      .catch((err) => {
        if (err?.response?.data?.detail) {
          toast(err.response.data.detail[0].msg, { type: "error" });
        } else {
          toast("Something went wrong!!");
        }
      })
      .finally(() => setLoader(false));
  };

  const getProfileApiCall = () => {
    setLoader(true);
    viewProfileService()
      .then(({ data }) => {
        setfranchiseLocation({
          lat: Number(data?.latitude),
          lng: Number(data?.longitude),
        });
      })
      .catch((err) => {
        const errMsg =
          err?.response?.data?.detail?.[0]?.msg || "Something went wrong!!";
        toast(errMsg, { type: "error" });
      })
      .finally(() => setLoader(false));
  };

  const onDeliveryChargeKeyDown = (e) => {
    const allowedKeys = [
      "Backspace",
      "Delete",
      "ArrowLeft",
      "ArrowRight",
      "Tab",
    ];

    if (allowedKeys.includes(e.key)) return;

    if (/^[0-9]$/.test(e.key)) return;

    if (e.key === "." && !e.target.value.includes(".")) return;
    e.preventDefault();
  };

  const isShowInFranchiseLoginMap = useMemo(() => {
    return (
      franchiseLocation?.lat &&
      franchiseLocation?.lng &&
      (values.selectedDeliveryType === 1 ||
        values.selectedDeliveryType === 3) &&
      state?.CustomerDetails?.latitude &&
      state?.CustomerDetails?.longitude
    );
  }, [
    franchiseLocation,
    values.selectedDeliveryType,
    state?.CustomerDetails?.latitude,
    state?.CustomerDetails?.longitude,
  ]);

  const isEditMap = useMemo(() => {
    return isEditDeliveryLocationMap || !values.deliveryGeo;
  }, [isEditDeliveryLocationMap, values.deliveryGeo]);

  const renderCustomerMap = useMemo(() => {
    return (
      <MapContainer
        isEdit={isEditMap}
        location={values.deliveryGeo}
        showCurrentLocation={true}
        onSelectLocation={(data) => {
          console.log(data, "KKK");
          setFieldValue("billingAddress", data.address);
          setFieldValue("deliveryGeo", data);
          setisEditDeliveryLocationMap(false);
        }}
      />
    );
    // return (
    //   <MapContainerLeaflet
    //     enableSelectLocation={isEditMap}
    //     location={values.deliveryGeo}
    //     onSelectLocation={(data) => {
    //       console.log(data, "KKK");

    //       setFieldValue("billingAddress", data.fullAddress);
    //       setFieldValue("deliveryGeo", data);
    //       setisEditDeliveryLocationMap(false);
    //     }}
    //   />
    // );
  }, [isEditMap, values.deliveryGeo]);

  const renderFranchiseMap = useMemo(() => {
    return (
      <MapContainerLeaflet
        showDirections={true}
        // origin={{ lat: 12.963257, lng: 77.62681 }}
        origin={franchiseLocation}
        location={{
          lat: state?.CustomerDetails?.latitude,
          lng: state?.CustomerDetails?.longitude,
        }}
        // location={{
        //   lat: DEFAULT_LOCATION.lat,
        //   lng: DEFAULT_LOCATION.lng,
        // }}
      />
    );
  }, [
    franchiseLocation,
    state?.CustomerDetails?.latitude,
    state?.CustomerDetails?.longitude,
  ]);

  return (
    <div className={Styles.overallParentContainer + " container-fluid"}>
      {pathname.includes("/kansas_product") ? <Header /> : null}
      <Loader isLoader={loader} />
      <div className={Styles.childParent}>
        <div className={Styles.overallChildContainer}>
          <div className={Styles.leftContainer}>
            <form onSubmit={(e) => e.preventDefault()}>
              <div className={Styles.overallLeftContainer}>
                {pathname.includes("/kansas_product") && (
                  <div className={Styles.formContainer}>
                    <div className={Styles.inputLeftContainer}>
                      <p className="fontBold" style={{ margin: "16px 0" }}>
                        Delivery <span className="orange">Options</span>
                      </p>

                      <OrderType
                        isCustomer={true}
                        allowedDeliveryType={shopDeliveryType}
                        selectedOrderType={values.selectedDeliveryType}
                        onChangeOrderType={(val) => {
                          setFieldValue("selectedDeliveryType", val);
                        }}
                      />

                      {values.selectedDeliveryType === 1 && (
                        <LocationInput
                          errorText={
                            touched.deliveryGeo && errors.deliveryGeo
                              ? errors.deliveryGeo
                              : ""
                          }
                          defaultAddress={values.deliveryGeo?.address ?? ""}
                          onSelectAddress={(data) => {
                            setFieldValue("billingAddress", data.address);
                            setFieldValue("deliveryGeo", data);
                          }}
                        />
                      )}
                    </div>
                    <div className={Styles.inputRightContainer}>
                      {values.selectedDeliveryType === 1 && (
                        <>
                          <div className={Styles.labelRow}>
                            <label className="label">
                              {/* Delivery Location{" "}
                              <span className="text-danger fs-5">*</span> */}
                            </label>

                            {/* <button
                              type="button"
                              className={Styles.editBtn}
                              onClick={() => {
                                setisEditDeliveryLocationMap((pre) => !pre);
                              }}
                            >
                              <img
                                src={isEditMap ? cancelIcon : editLocationIcon}
                                alt={
                                  isEditMap ? "cancel_edit" : "edit location"
                                }
                              />
                            </button> */}

                            <button
                              className={Styles.addressBookButton}
                              onClick={() => {
                                setisEditDeliveryLocationMap((pre) => !pre);
                              }}
                            >
                              <img
                                src={isEditMap ? cancelIcon : editLocationIcon}
                                alt={
                                  isEditMap ? "cancel_edit" : "edit location"
                                }
                                className={Styles.addressBookIcon}
                              />
                              <span className={Styles.addressBookText}>
                                {isEditMap ? "Cancel" : "Edit"}
                              </span>
                            </button>
                          </div>

                          {renderCustomerMap}

                          <p className={Styles.instructionText}>
                            {isEditMap
                              ? "Drag the map to select your delivery location."
                              : values.billingAddress}
                          </p>

                          {touched.deliveryGeo && errors.deliveryGeo && (
                            <div className={Styles.errMsg + " text-danger"}>
                              {errors.deliveryGeo}
                            </div>
                          )}
                        </>
                        // <MapContainer location={values.deliveryGeo} />
                      )}
                    </div>
                  </div>
                )}
                {pathname.includes("/store") && (
                  <div className={Styles.formContainer}>
                    <div className={Styles.inputLeftContainer}>
                      <p className="fontBold" style={{ margin: "16px 0" }}>
                        Delivery <span className="orange">Options</span>
                      </p>

                      <OrderType
                        isCustomer={false}
                        showOnlyTakeAway={
                          state?.CustomerDetails?.delivery_type === 2 ||
                          !state?.CustomerDetails?.delivery_type ||
                          !state?.CustomerDetails?.latitude ||
                          !state?.CustomerDetails?.longitude
                        }
                        isNew={
                          !state?.CustomerDetails?.delivery_type ||
                          !state?.CustomerDetails?.latitude ||
                          !state?.CustomerDetails?.longitude
                        }
                        selectedOrderType={values.selectedDeliveryType}
                        onChangeOrderType={(val) => {
                          setFieldValue("selectedDeliveryType", val);
                        }}
                      />
                      {touched.selectedDeliveryType &&
                        errors.selectedDeliveryType && (
                          <div className={Styles.errMsg + " text-danger"}>
                            {errors.selectedDeliveryType}
                          </div>
                        )}
                    </div>
                    {isShowInFranchiseLoginMap && (
                      <div className={Styles.inputRightContainer}>
                        {renderFranchiseMap}
                        {/* <MapContainer
                          showDirections={true}
                          // origin={{ lat: 12.963257, lng: 77.62681 }}
                          origin={franchiseLocation}
                          location={{
                            lat: state?.CustomerDetails?.latitude,
                            lng: state?.CustomerDetails?.longitude,
                          }}
                          // location={{
                          //   lat: DEFAULT_LOCATION.lat,
                          //   lng: DEFAULT_LOCATION.lng,
                          // }}
                        /> */}
                      </div>
                    )}
                  </div>
                )}

                <div className={Styles.headingRow}>
                  <p
                    className={`fontBold`}
                    style={
                      pathname.includes("/kansas_product") &&
                      values.selectedDeliveryType === 1
                        ? { marginTop: "20px" }
                        : {}
                    }
                  >
                    Billing <span className="orange">Details</span>
                  </p>

                  {getSavedAddressesList(true).length > 0 &&
                    pathname.includes("/kansas_product") && (
                      <button
                        className={Styles.addressBookButton}
                        onClick={() => {
                          setaddressListPopupData({
                            status: true,
                            isSave: false,
                            isBilling: true,
                          });
                        }}
                        style={
                          pathname.includes("/kansas_product") &&
                          values.selectedDeliveryType === 1
                            ? {
                                marginTop: "20px",
                              }
                            : {}
                        }
                      >
                        <img
                          src={bookPrimary}
                          alt="address-book"
                          className={Styles.addressBookIcon}
                        />
                        <span className={Styles.addressBookText}>
                          Saved Address
                        </span>
                      </button>
                    )}
                </div>

                <div className={Styles.formContainer}>
                  <div className={Styles.inputLeftContainer}>
                    <label className="label">
                      Name <span className="text-danger fs-5">*</span>
                    </label>
                    <div
                      className={clsx(Styles.inputContainer, {
                        [Styles.disabled]: isDisabled,
                      })}
                    >
                      <input
                        type="text"
                        name="billingName"
                        value={values.billingName}
                        onChange={handleChange}
                        disabled={isDisabled}
                        placeholder="Enter Your Name"
                        className={Styles.input + " kstoreFont"}
                      />
                    </div>
                    {touched.billingName && errors.billingName ? (
                      <div className={Styles.errMsg + " text-danger"}>
                        {errors.billingName}
                      </div>
                    ) : null}
                  </div>

                  <div className={Styles.inputRightContainer}>
                    <label className="label">
                      Mobile Number <span className="text-danger fs-5">*</span>
                    </label>
                    <div
                      className={clsx(Styles.inputContainer, {
                        [Styles.disabled]: isDisabled,
                      })}
                    >
                      <input
                        type="text"
                        name="billingMobile"
                        value={values.billingMobile}
                        onChange={handleChange}
                        placeholder="Enter Your Mobile Number"
                        maxLength="10"
                        disabled={isDisabled}
                        className={Styles.input + " kstoreFont"}
                        onKeyPress={(e) => {
                          if (!(e.key === "0" || parseInt(e.key))) {
                            e.preventDefault();
                          }
                        }}
                      />
                    </div>
                    {touched.billingMobile && errors.billingMobile ? (
                      <div className={Styles.errMsg + " text-danger"}>
                        {errors.billingMobile}
                      </div>
                    ) : null}
                  </div>
                </div>

                <div className={Styles.formContainer}>
                  <div className={Styles.inputLeftContainer}>
                    <label className="label">
                      State <span className="text-danger fs-5">*</span>
                    </label>
                    <ReactSelect
                      className="basic-single kstoreFont mt-2"
                      classNamePrefix="select"
                      name="billingState"
                      placeholder="Select State..."
                      isClearable={false}
                      isDisabled={isDisabled}
                      value={states.find(
                        (e) => e.state_id === values.billingState,
                      )}
                      styles={customStyles}
                      options={states}
                      getOptionLabel={(e) => e.state_name}
                      getOptionValue={(e) => e.state_name}
                      onChange={(e) => {
                        handleCity(e.state_id, true);
                        setFieldValue("billingState", e.state_id);
                        setFieldValue("state_name", e.state_name);
                        setSelectRef({
                          ...selectRef,
                          state: e.state_name,
                          city: "",
                        });

                        setFieldValue("billingCity", "");
                      }}
                    />
                    {touched.billingState && errors.billingState ? (
                      <div className={Styles.errMsg + " text-danger"}>
                        {errors.billingState}
                      </div>
                    ) : null}
                  </div>
                  <div className={Styles.inputRightContainer}>
                    <label className="label">
                      City <span className="text-danger fs-5">*</span>
                    </label>
                    <ReactSelect
                      className="basic-single kstoreFont mt-2"
                      classNamePrefix="select"
                      placeholder="Select City..."
                      name="billingCity"
                      isDisabled={isDisabled}
                      // defaultInputValue={selectRef.city}
                      value={billingCitiesList.find(
                        (e) => e.cities_id === values.billingCity,
                      )}
                      isClearable={false}
                      styles={customStyles}
                      options={billingCitiesList}
                      getOptionLabel={(e) => e.cities_name}
                      getOptionValue={(e) => e.cities_name}
                      onChange={(e) => {
                        setSelectRef({ ...selectRef, city: e.cities_name });
                        setFieldValue("billingCity", e.cities_id);
                        setFieldValue("city_name", e.cities_name);
                      }}
                      key={values.billingCity !== "" ? Math.random() : "123"}
                    />
                    {touched.billingCity && errors.billingCity ? (
                      <div className={Styles.errMsg + " text-danger"}>
                        {errors.billingCity}
                      </div>
                    ) : null}
                  </div>
                </div>

                <div className={Styles.formContainer}>
                  <div className={Styles.inputLeftContainer}>
                    <label className="label">
                      Address
                      <span className="text-danger fs-5">*</span>
                    </label>
                    <div
                      className={clsx(Styles.inputContainer, {
                        [Styles.disabled]: isDisabled,
                      })}
                    >
                      <input
                        type="text"
                        name="billingAddress"
                        value={values.billingAddress}
                        disabled={isDisabled}
                        onChange={handleChange}
                        placeholder="Enter Your Address"
                        className={Styles.input + " kstoreFont"}
                      />
                    </div>
                    {touched.billingAddress && errors.billingAddress ? (
                      <div className={Styles.errMsg + " text-danger"}>
                        {errors.billingAddress}
                      </div>
                    ) : null}
                  </div>
                  <div className={Styles.inputRightContainer}>
                    <label className="label">
                      email
                      {/* <span className="text-danger fs-5">*</span> */}
                    </label>
                    <div
                      className={clsx(Styles.inputContainer, {
                        [Styles.disabled]: isDisabled,
                      })}
                    >
                      <input
                        type="text"
                        name="billingEmail"
                        value={values.billingEmail}
                        disabled={isDisabled}
                        onChange={handleChange}
                        placeholder="Enter Your email"
                        className={Styles.input + " kstoreFont6"}
                      />
                    </div>
                    {touched.billingEmail && errors.billingEmail ? (
                      <div className={Styles.errMsg + " text-danger"}>
                        {errors.billingEmail}
                      </div>
                    ) : null}
                  </div>
                </div>

                <div className={Styles.formContainer}>
                  <div className={Styles.inputLeftContainer}>
                    <label className="label">
                      Pincode <span className="text-danger fs-5">*</span>
                    </label>
                    <div
                      className={clsx(Styles.inputContainer, {
                        [Styles.disabled]: isDisabled,
                      })}
                    >
                      <input
                        type="text"
                        name="billingPincode"
                        value={values.billingPincode}
                        placeholder="Enter Pincode"
                        onChange={handleChange}
                        disabled={isDisabled}
                        maxLength="6"
                        className={Styles.input + " kstoreFont"}
                        onKeyPress={(e) => {
                          if (!(e.key === "0" || parseInt(e.key))) {
                            e.preventDefault();
                          }
                        }}
                      />
                    </div>
                    {touched.billingPincode && errors.billingPincode ? (
                      <div className={Styles.errMsg + " text-danger"}>
                        {errors.billingPincode}
                      </div>
                    ) : null}
                  </div>
                  {state?.status !== 2 ? (
                    <div className={Styles.inputRightContainer}>
                      <label className="label">GST Number</label>
                      <div className={Styles.inputContainer}>
                        <input
                          type="text"
                          name="gst_no"
                          value={values.gst_no}
                          placeholder="Enter GST Number"
                          maxLength={15}
                          onChange={handleChange}
                          className={Styles.input + " kstoreFont"}
                        />
                      </div>
                      {touched.gst_no && errors.gst_no ? (
                        <div className={Styles.errMsg + " text-danger"}>
                          {errors.gst_no}
                        </div>
                      ) : null}
                    </div>
                  ) : null}
                </div>
                {state?.status !== 2 ? (
                  <>
                    {[15280, 16641, 14936].includes(values?.id) ? (
                      <>
                        {" "}
                        <div className={Styles.formContainer}>
                          <div className={Styles.inputLeftContainer}>
                            <label className="label">
                              Dealer Code{" "}
                              {[15280, 16641, 14936].includes(values?.id) ? (
                                <span className="text-danger fs-5">*</span>
                              ) : null}
                            </label>
                            <div className={Styles.inputContainer}>
                              <input
                                type="text"
                                name="DealerCode"
                                placeholder="Enter Dealer code"
                                value={values.DealerCode}
                                maxLength={10}
                                onChange={handleChange}
                                className={Styles.input + " kstoreFont"}
                              />
                            </div>
                            {touched?.DealerCode && errors?.DealerCode ? (
                              <div className={Styles.errMsg + " text-danger"}>
                                {errors?.DealerCode}
                              </div>
                            ) : null}
                          </div>
                        </div>
                      </>
                    ) : null}
                  </>
                ) : null}
                {state?.status && state?.status !== 2 ? (
                  <div className={Styles.formContainer}>
                    <div className={Styles.inputLeftContainer}>
                      <label className="label">
                        Invoice Number
                        <span className="text-danger fs-5">*</span>
                      </label>
                      <div
                        className={clsx(Styles.inputContainer, {
                          [Styles.disabled]: isEnabledAutoInvoice,
                        })}
                      >
                        <input
                          type="text"
                          name="invoice_no"
                          disabled={isEnabledAutoInvoice}
                          value={values.invoice_no}
                          placeholder="Enter Invoice Number"
                          maxLength={50}
                          onChange={(e) => {
                            if (!isEnabledAutoInvoice) {
                              setFieldValue("invoice_no", e.target.value);
                            }
                          }}
                          // onChange={handleChange}
                          className={Styles.input + " kstoreFont"}
                        />
                      </div>
                      {touched.invoice_no && errors.invoice_no ? (
                        <div className={Styles.errMsg + " text-danger"}>
                          {errors.invoice_no}
                        </div>
                      ) : null}
                    </div>
                    {state?.showDeliveryCharge &&
                    (state?.CustomerDetails?.delivery_type === 1 ||
                      state?.CustomerDetails?.delivery_type === 3 ||
                      (!state?.CustomerDetails?.delivery_type &&
                        values.selectedDeliveryType === 3)) ? (
                      <div className={Styles.inputLeftContainer}>
                        <label className="label">Delivery Charge</label>
                        <div className={Styles.inputContainer}>
                          <input
                            type="text"
                            name="delivery_charge"
                            value={values.delivery_charge}
                            placeholder="Enter Delivery Charge"
                            onChange={handleChange}
                            onKeyDown={onDeliveryChargeKeyDown}
                            className={Styles.input + " kstoreFont"}
                          />
                        </div>
                        {touched.delivery_charge && errors.delivery_charge ? (
                          <div className={Styles.errMsg + " text-danger"}>
                            {errors.delivery_charge}
                          </div>
                        ) : null}
                      </div>
                    ) : (
                      false
                    )}
                  </div>
                ) : null}
                {pathname.includes("/kansas_product") && (
                  <div className={Styles.inputLeftContainer}>
                    <button
                      onClick={() => {
                        if (!isErrorInAddress(true)) {
                          if (getSavedAddressesList(true).length > 0) {
                            setaddressListPopupData({
                              status: true,
                              isSave: true,
                              isBilling: true,
                            });
                          } else {
                            handleSaveUpdateAddress(true);
                          }
                        } else {
                          toast("Please enter all required billing details.", {
                            type: "error",
                          });
                        }
                      }}
                      style={{
                        marginRight: "25px",
                        backgroundColor: isErrorInAddress(true)
                          ? "grey"
                          : "#f27f0c",
                      }}
                      className={Styles.saveAddressBtn}
                      disabled={isErrorInAddress(true)}
                    >
                      <img className={Styles.nextIcon} src={save} alt="save" />
                      Save Billing Address
                    </button>
                  </div>
                )}

                <div className={Styles.headingRow}>
                  <p className={`fontBold`}>
                    Shipping <span className="orange">Address</span>
                  </p>

                  {isShowShipping &&
                    getSavedAddressesList(false).length > 0 &&
                    pathname.includes("/kansas_product") && (
                      <button
                        className={Styles.addressBookButton}
                        onClick={() => {
                          setaddressListPopupData({
                            status: true,
                            isSave: false,
                            isBilling: false,
                          });
                        }}
                      >
                        <img
                          src={bookPrimary}
                          alt="address-book"
                          className={Styles.addressBookIcon}
                        />
                        <span className={Styles.addressBookText}>
                          Saved Address
                        </span>
                      </button>
                    )}
                </div>

                <div className={Styles.checkboxContainer}>
                  <input
                    className={Styles.ShowShippingDetail}
                    type="checkbox"
                    value={isShowShipping}
                    checked={!isShowShipping}
                    disabled={isDisabled}
                    onChange={() => setIsShowShipping(!isShowShipping)}
                  />
                  <label className={Styles.shippingLabel + " kstoreFont ps-2"}>
                    Shipping Address Same as Billing Address
                  </label>
                </div>
                <div style={{ display: isShowShipping ? "block" : "none" }}>
                  <div className={Styles.formContainer}>
                    <div className={Styles.inputLeftContainer}>
                      <label className="label">
                        Name <span className="text-danger fs-5">*</span>
                      </label>
                      <div className={Styles.inputContainer}>
                        <input
                          type="text"
                          onChange={handleChange}
                          name="shippingName"
                          value={values.shippingName}
                          placeholder="Enter Your Name"
                          className={Styles.input + " kstoreFont"}
                        />
                      </div>
                      {touched.shippingName && errors.shippingName ? (
                        <div className={Styles.errMsg + " text-danger"}>
                          {errors.shippingName}
                        </div>
                      ) : null}
                    </div>

                    <div className={Styles.inputRightContainer}>
                      <label className="label">
                        Mobile Number{" "}
                        <span className="text-danger fs-5">*</span>
                      </label>
                      <div className={Styles.inputContainer}>
                        <input
                          type="text"
                          name="shippingMobile"
                          value={values.shippingMobile}
                          onChange={handleChange}
                          placeholder="Enter Your Mobile Number"
                          maxLength="10"
                          className={Styles.input + " kstoreFont"}
                          onKeyPress={(e) => {
                            if (!(e.key === "0" || parseInt(e.key))) {
                              e.preventDefault();
                            }
                          }}
                        />
                      </div>
                      {touched.shippingMobile && errors.shippingMobile ? (
                        <div className={Styles.errMsg + " text-danger"}>
                          {errors.shippingMobile}
                        </div>
                      ) : null}
                    </div>
                  </div>

                  <div className={Styles.formContainer}>
                    <div className={Styles.inputLeftContainer}>
                      <label className="label">
                        State <span className="text-danger fs-5">*</span>
                      </label>
                      <ReactSelect
                        className="basic-single kstoreFont mt-2"
                        classNamePrefix="select"
                        name="shippingState"
                        placeholder="Select State..."
                        isClearable={false}
                        value={states.find(
                          (e) => e.state_id === values.shippingState,
                        )}
                        styles={customStyles}
                        options={states}
                        getOptionLabel={(e) => e.state_name}
                        getOptionValue={(e) => e.state_name}
                        onChange={(e) => {
                          handleCity(e.state_id, false);
                          setFieldValue("shippingState", e.state_id);
                          setFieldValue("shipping_statename", e.state_name);
                          setSelectRef({
                            ...selectRef,
                            state: e.state_name,
                            city: "",
                          });
                        }}
                      />
                      {touched.shippingState && errors.shippingState ? (
                        <div className={Styles.errMsg + " text-danger"}>
                          {errors.shippingState}
                        </div>
                      ) : null}
                    </div>
                    <div className={Styles.inputRightContainer}>
                      <label className="label">
                        City <span className="text-danger fs-5">*</span>
                      </label>
                      <ReactSelect
                        className="basic-single kstoreFont mt-2"
                        classNamePrefix="select"
                        placeholder="Select City..."
                        name="shippingCity"
                        // defaultInputValue={selectRef.city}
                        value={shippingCitiesList.find(
                          (e) => e.cities_id === values.shippingCity,
                        )}
                        isClearable={false}
                        styles={customStyles}
                        options={shippingCitiesList}
                        getOptionLabel={(e) => e.cities_name}
                        getOptionValue={(e) => e.cities_name}
                        onChange={(e) => {
                          setSelectRef({ ...selectRef, city: e.cities_name });
                          setFieldValue("shippingCity", e.cities_id);
                          setFieldValue("shipping_cityname", e.cities_name);
                        }}
                        key={values.shippingCity !== "" ? Math.random() : "123"}
                      />
                      {touched.shippingCity && errors.shippingCity ? (
                        <div className={Styles.errMsg + " text-danger"}>
                          {errors.shippingCity}
                        </div>
                      ) : null}
                    </div>
                  </div>

                  <div className={Styles.formContainer}>
                    <div className={Styles.inputLeftContainer}>
                      <label className="label">
                        Address
                        <span className="text-danger fs-5">*</span>
                      </label>
                      <div className={Styles.inputContainer}>
                        <input
                          type="text"
                          name="shippingAddress"
                          value={values.shippingAddress}
                          onChange={handleChange}
                          placeholder="Enter Your Address"
                          className={Styles.input + " kstoreFont"}
                        />
                      </div>
                      {touched.shippingAddress && errors.shippingAddress ? (
                        <div className={Styles.errMsg + " text-danger"}>
                          {errors.shippingAddress}
                        </div>
                      ) : null}
                    </div>
                    <div className={Styles.inputRightContainer}>
                      <label className="label">
                        email
                        {/* <span className="text-danger fs-5">*</span> */}
                      </label>
                      <div className={Styles.inputContainer}>
                        <input
                          type="text"
                          name="shippingEmail"
                          onChange={handleChange}
                          value={values.shippingEmail}
                          placeholder="Enter Your email"
                          className={Styles.input + " kstoreFont6"}
                        />
                      </div>
                      {touched.shippingEmail && errors.shippingEmail ? (
                        <div className={Styles.errMsg + " text-danger"}>
                          {errors.shippingEmail}
                        </div>
                      ) : null}
                    </div>
                  </div>

                  <div className={Styles.formContainer}>
                    <div className={Styles.inputLeftContainer}>
                      <label className="label">
                        Pincode <span className="text-danger fs-5">*</span>
                      </label>
                      <div className={Styles.inputContainer}>
                        <input
                          type="text"
                          name="shippingPincode"
                          placeholder="Enter Pincode"
                          maxLength="6"
                          value={values.shippingPincode}
                          onChange={handleChange}
                          className={Styles.input + " kstoreFont"}
                          onKeyPress={(e) => {
                            if (!(e.key === "0" || parseInt(e.key))) {
                              e.preventDefault();
                            }
                          }}
                        />
                      </div>
                      {touched.shippingPincode && errors.shippingPincode ? (
                        <div className={Styles.errMsg + " text-danger"}>
                          {errors.shippingPincode}
                        </div>
                      ) : null}
                    </div>
                  </div>
                </div>

                {state?.status === 1 &&
                !pathname.includes("/kansas_product") ? (
                  <div className={Styles.paymentContainer}>
                    <p className={Styles.paymentTitle + " fontBold"}>
                      Payment <span className="orange">Mode</span> - Dealer{" "}
                    </p>

                    {/* <div className={Styles.paymentSec}>
                      <input
                        value="1"
                        className={
                          Styles.paymentRadioBtn + " align-self-center"
                        }
                        type="radio"
                        onChange={() => setFieldValue("paymentStatus", 1)}
                        checked={parseInt(values.paymentStatus) === 1}
                      />
                      <label
                        onClick={() => setFieldValue("paymentStatus", 1)}
                        className={Styles.paymentLabel + " label"}
                      >
                        UPI
                      </label>
                    </div> */}

                    {/* <div className={Styles.paymentSec}>
                      <input
                        value="7"
                        className={
                          Styles.paymentRadioBtn + " align-self-center"
                        }
                        type="radio"
                        onChange={() => setFieldValue("paymentStatus", 7)}
                        checked={parseInt(values.paymentStatus) === 7}
                      />
                      <label
                        onClick={() => setFieldValue("paymentStatus", 7)}
                        className={Styles.paymentLabel + " label"}
                      >
                        QR Code
                      </label>
                    </div> */}

                    {/* <div className={Styles.paymentSec}>
                      <input
                        value="2"
                        className={
                          Styles.paymentRadioBtn + " align-self-center"
                        }
                        type="radio"
                        onChange={() => setFieldValue("paymentStatus", 2)}
                        checked={parseInt(values.paymentStatus) === 2}
                      />
                      <label
                        onClick={() => setFieldValue("paymentStatus", 2)}
                        className={Styles.paymentLabel + " label"}
                      >
                        CREDIT / DEBIT / NET BANKING
                      </label>
                    </div> */}

                    <div className={Styles.paymentSec}>
                      <input
                        value="9"
                        className={
                          Styles.paymentRadioBtn + " align-self-center"
                        }
                        type="radio"
                        onChange={() => setFieldValue("paymentStatus", 9)}
                        checked={parseInt(values.paymentStatus) === 9}
                      />
                      <label
                        onClick={() => setFieldValue("paymentStatus", 9)}
                        className={Styles.paymentLabel + " label"}
                      >
                        CREDIT
                      </label>
                    </div>

                    <div className={Styles.paymentSec}>
                      <input
                        value="3"
                        className={
                          Styles.paymentRadioBtn + " align-self-center"
                        }
                        type="radio"
                        onChange={() => setFieldValue("paymentStatus", 3)}
                        checked={parseInt(values.paymentStatus) === 3}
                      />
                      <label
                        onClick={() => setFieldValue("paymentStatus", 3)}
                        className={Styles.paymentLabel + " label"}
                      >
                        CASH
                      </label>
                    </div>
                    {/* <div className={Styles.paymentSec}>
                      <input
                        value="3"
                        className={
                          Styles.paymentRadioBtn + " align-self-center"
                        }
                        type="radio"
                        onChange={() => setFieldValue("paymentStatus", 4)}
                        checked={parseInt(values.paymentStatus) === 4}
                      />
                      <label
                        onClick={() => setFieldValue("paymentStatus", 4)}
                        className={Styles.paymentLabel + " label"}
                      >
                        EMI
                      </label>
                      {values.paymentStatus === 4 ? (
                        <select
                          name="emiOption"
                          value={values.emiOption}
                          onChange={(e) => {
                            setFieldValue("emiOption", e.target.value);
                          }}
                          className={Styles.selectPayment}
                        >
                          <option>Select Emi Provider</option>
                          {emiProviders?.map((ele) => (
                            <option
                              onClick={() =>
                                setFieldValue("emiProvidername", ele.name)
                              }
                              value={ele.emi_type_id}
                            >
                              {ele.name}
                            </option>
                          ))}
                        </select>
                      ) : null}
                      {touched.emiOption &&
                      errors.emiOption &&
                      values.paymentStatus === 4 ? (
                        <div
                          className={
                            Styles.errMsg +
                            " text-danger align-self-center ps-3"
                          }
                        >
                          {errors.emiOption}
                        </div>
                      ) : null}
                      <div className={Styles.otherPaymentBox}>
                        {values.emiOption == 4 && values.paymentStatus === 4 ? (
                          <div className={Styles.paymentSec}>
                            <input
                              type="text"
                              name="OtherEmiOption"
                              className={Styles.pos}
                              value={values.OtherEmiOption}
                              onChange={(e) =>
                                setFieldValue("OtherEmiOption", e.target.value)
                              }
                              placeholder="Enter Other Options"
                            />
                          </div>
                        ) : null}
                        {touched.OtherEmiOption &&
                        errors.OtherEmiOption &&
                        values.paymentStatus === 4 ? (
                          <div
                            className={
                              Styles.errMsg +
                              " text-danger align-self-center ps-3"
                            }
                          >
                            {errors.OtherEmiOption}
                          </div>
                        ) : null}
                      </div>
                    </div> */}

                    <div className={Styles.paymentSec}>
                      <input
                        value="3"
                        className={
                          Styles.paymentRadioBtn + " align-self-center"
                        }
                        type="radio"
                        onChange={() => setFieldValue("paymentStatus", 10)}
                        checked={parseInt(values.paymentStatus) === 10}
                      />
                      <label
                        onClick={() => setFieldValue("paymentStatus", 10)}
                        className={Styles.paymentLabel + " label"}
                      >
                        POS Machine / UPI / CARD
                      </label>
                      {values.paymentStatus === 10 ? (
                        <input
                          type="text"
                          name="posMachine"
                          className={Styles.pos}
                          value={values.posMachine}
                          onChange={(e) =>
                            setFieldValue("posMachine", e.target.value)
                          }
                          placeholder="Enter Transaction id"
                        />
                      ) : null}
                      {touched.posMachine &&
                      errors.posMachine &&
                      values.paymentStatus === 10 ? (
                        <div
                          className={
                            Styles.errMsg +
                            " text-danger align-self-center ps-3"
                          }
                        >
                          {errors.posMachine}
                        </div>
                      ) : null}
                    </div>

                    {/* <div className={Styles.paymentSec}>
                      <input
                        value="8"
                        className={
                          Styles.paymentRadioBtn + " align-self-center"
                        }
                        type="radio"
                        onChange={() => setFieldValue("paymentStatus", 8)}
                        checked={parseInt(values.paymentStatus) === 8}
                      />
                      <label
                        onClick={() => setFieldValue("paymentStatus", 8)}
                        className={Styles.paymentLabel + " label"}
                      >
                        Payment Gateway - KANSAS
                      </label>
                    </div> */}

                    {/* <div className={Styles.paymentSec}>
                      <input
                        value="9"
                        className={
                          Styles.paymentRadioBtn + " align-self-center"
                        }
                        type="radio"
                        onChange={() => setFieldValue("paymentStatus", 9)}
                        checked={parseInt(values.paymentStatus) === 9}
                      />
                      <label
                        onClick={() => setFieldValue("paymentStatus", 9)}
                        className={Styles.paymentLabel + " label"}
                      >
                        Others
                      </label>

                      {touched.Others &&
                      errors.Others &&
                      values.paymentStatus === 9 ? (
                        <div
                          className={
                            Styles.errMsg +
                            " text-danger align-self-center ps-3"
                          }
                        >
                          {errors.Others}
                        </div>
                      ) : null}
                    </div> */}

                    {/* <div className={Styles.paymentSec}>
                      <input
                        value="3"
                        className={
                          Styles.paymentRadioBtn + " align-self-center"
                        }
                        type="radio"
                        onChange={() => {
                          setFieldValue("paymentStatus", 6);
                        }}
                        checked={parseInt(values.paymentStatus) === 6}
                      />
                      <label
                        onClick={() => {
                          setFieldValue("paymentStatus", 6);
                        }}
                        className={Styles.paymentLabel + " label"}
                      >
                        Send Payment Link
                      </label>
                      {values.paymentStatus === 6 ? (
                        <input
                          name="paymentLinkNo"
                          onKeyPress={(e) => {
                            if (e.key === "0" || parseInt(e.key)) {
                            } else {
                              e.preventDefault();
                            }
                          }}
                          onChange={(e) => {
                            setFieldValue("paymentLinkNo", e.target.value);
                          }}
                          type="text"
                          maxLength={10}
                          value={values.paymentLinkNo}
                          placeholder="Enter Mobile Number"
                          className={Styles.pos}
                        />
                      ) : null}
                    </div> */}
                    {touched.paymentLinkNo &&
                    errors.paymentLinkNo &&
                    values.paymentStatus === 6 ? (
                      <div
                        className={
                          Styles.errMsg + " text-danger align-self-center ps-3"
                        }
                      >
                        {errors.paymentLinkNo}
                      </div>
                    ) : null}
                    {touched.paymentStatus && errors.paymentStatus ? (
                      <div className={Styles.errMsg + " text-danger"}>
                        {errors.paymentStatus}
                      </div>
                    ) : null}
                  </div>
                ) : null}

                {state?.status === 1 &&
                !pathname.includes("/kansas_product") ? (
                  <div
                    className={Styles.paymentContainer}
                    style={{ marginTop: 10 }}
                  >
                    <p className={Styles.paymentTitle + " fontBold"}>
                      Payment <span className="orange">Mode</span> - KANSAS
                      (Optional){" "}
                    </p>

                    {/* <div className={Styles.paymentSec}>
                      <input
                        value="1"
                        className={
                          Styles.paymentRadioBtn + " align-self-center"
                        }
                        type="radio"
                        onChange={() => setFieldValue("paymentStatus", 1)}
                        checked={parseInt(values.paymentStatus) === 1}
                      />
                      <label
                        onClick={() => setFieldValue("paymentStatus", 1)}
                        className={Styles.paymentLabel + " label"}
                      >
                        UPI
                      </label>
                    </div> */}

                    {/* <div className={Styles.paymentSec}>
                      <input
                        value="7"
                        className={
                          Styles.paymentRadioBtn + " align-self-center"
                        }
                        type="radio"
                        onChange={() => setFieldValue("paymentStatus", 7)}
                        checked={parseInt(values.paymentStatus) === 7}
                      />
                      <label
                        onClick={() => setFieldValue("paymentStatus", 7)}
                        className={Styles.paymentLabel + " label"}
                      >
                        QR Code
                      </label>
                    </div> */}

                    {/* <div className={Styles.paymentSec}>
                      <input
                        value="2"
                        className={
                          Styles.paymentRadioBtn + " align-self-center"
                        }
                        type="radio"
                        onChange={() => setFieldValue("paymentStatus", 2)}
                        checked={parseInt(values.paymentStatus) === 2}
                      />
                      <label
                        onClick={() => setFieldValue("paymentStatus", 2)}
                        className={Styles.paymentLabel + " label"}
                      >
                        CREDIT / DEBIT / NET BANKING
                      </label>
                    </div> */}

                    {/* <div className={Styles.paymentSec}>
                      <input
                        value="9"
                        className={
                          Styles.paymentRadioBtn + " align-self-center"
                        }
                        type="radio"
                        onChange={() => setFieldValue("paymentStatus", 9)}
                        checked={parseInt(values.paymentStatus) === 9}
                      />
                      <label
                        onClick={() => setFieldValue("paymentStatus", 9)}
                        className={Styles.paymentLabel + " label"}
                      >
                        CREDIT
                      </label>
                    </div> */}

                    {/* <div className={Styles.paymentSec}>
                      <input
                        value="3"
                        className={
                          Styles.paymentRadioBtn + " align-self-center"
                        }
                        type="radio"
                        onChange={() => setFieldValue("paymentStatus", 3)}
                        checked={parseInt(values.paymentStatus) === 3}
                      />
                      <label
                        onClick={() => setFieldValue("paymentStatus", 3)}
                        className={Styles.paymentLabel + " label"}
                      >
                        CASH
                      </label>
                    </div> */}
                    {/* <div className={Styles.paymentSec}>
                      <input
                        value="3"
                        className={
                          Styles.paymentRadioBtn + " align-self-center"
                        }
                        type="radio"
                        onChange={() => setFieldValue("paymentStatus", 4)}
                        checked={parseInt(values.paymentStatus) === 4}
                      />
                      <label
                        onClick={() => setFieldValue("paymentStatus", 4)}
                        className={Styles.paymentLabel + " label"}
                      >
                        EMI
                      </label>
                      {values.paymentStatus === 4 ? (
                        <select
                          name="emiOption"
                          value={values.emiOption}
                          onChange={(e) => {
                            setFieldValue("emiOption", e.target.value);
                          }}
                          className={Styles.selectPayment}
                        >
                          <option>Select Emi Provider</option>
                          {emiProviders?.map((ele) => (
                            <option
                              onClick={() =>
                                setFieldValue("emiProvidername", ele.name)
                              }
                              value={ele.emi_type_id}
                            >
                              {ele.name}
                            </option>
                          ))}
                        </select>
                      ) : null}
                      {touched.emiOption &&
                      errors.emiOption &&
                      values.paymentStatus === 4 ? (
                        <div
                          className={
                            Styles.errMsg +
                            " text-danger align-self-center ps-3"
                          }
                        >
                          {errors.emiOption}
                        </div>
                      ) : null}
                      <div className={Styles.otherPaymentBox}>
                        {values.emiOption == 4 && values.paymentStatus === 4 ? (
                          <div className={Styles.paymentSec}>
                            <input
                              type="text"
                              name="OtherEmiOption"
                              className={Styles.pos}
                              value={values.OtherEmiOption}
                              onChange={(e) =>
                                setFieldValue("OtherEmiOption", e.target.value)
                              }
                              placeholder="Enter Other Options"
                            />
                          </div>
                        ) : null}
                        {touched.OtherEmiOption &&
                        errors.OtherEmiOption &&
                        values.paymentStatus === 4 ? (
                          <div
                            className={
                              Styles.errMsg +
                              " text-danger align-self-center ps-3"
                            }
                          >
                            {errors.OtherEmiOption}
                          </div>
                        ) : null}
                      </div>
                    </div> */}

                    {/* <div className={Styles.paymentSec}>
                      <input
                        value="3"
                        className={
                          Styles.paymentRadioBtn + " align-self-center"
                        }
                        type="radio"
                        onChange={() => setFieldValue("paymentStatus", 5)}
                        checked={parseInt(values.paymentStatus) === 5}
                      />
                      <label
                        onClick={() => setFieldValue("paymentStatus", 5)}
                        className={Styles.paymentLabel + " label"}
                      >
                        POS Machine / UPI / CARD
                      </label>
                      {values.paymentStatus === 5 ? (
                        <input
                          type="text"
                          name="posMachine"
                          className={Styles.pos}
                          value={values.posMachine}
                          onChange={(e) =>
                            setFieldValue("posMachine", e.target.value)
                          }
                          placeholder="Enter Transaction id"
                        />
                      ) : null}
                      {touched.posMachine &&
                      errors.posMachine &&
                      values.paymentStatus === 5 ? (
                        <div
                          className={
                            Styles.errMsg +
                            " text-danger align-self-center ps-3"
                          }
                        >
                          {errors.posMachine}
                        </div>
                      ) : null}
                    </div> */}

                    <div className={Styles.paymentSec}>
                      <input
                        value="8"
                        className={
                          Styles.paymentRadioBtn + " align-self-center"
                        }
                        type="radio"
                        onChange={() => setFieldValue("paymentStatus", 8)}
                        checked={parseInt(values.paymentStatus) === 8}
                      />
                      <label
                        onClick={() => setFieldValue("paymentStatus", 8)}
                        className={Styles.paymentLabel + " label"}
                      >
                        Payment Gateway
                      </label>
                    </div>

                    {/* <div className={Styles.paymentSec}>
                      <input
                        value="9"
                        className={
                          Styles.paymentRadioBtn + " align-self-center"
                        }
                        type="radio"
                        onChange={() => setFieldValue("paymentStatus", 9)}
                        checked={parseInt(values.paymentStatus) === 9}
                      />
                      <label
                        onClick={() => setFieldValue("paymentStatus", 9)}
                        className={Styles.paymentLabel + " label"}
                      >
                        Others
                      </label>

                      {touched.Others &&
                      errors.Others &&
                      values.paymentStatus === 9 ? (
                        <div
                          className={
                            Styles.errMsg +
                            " text-danger align-self-center ps-3"
                          }
                        >
                          {errors.Others}
                        </div>
                      ) : null}
                    </div> */}

                    {/* <div className={Styles.paymentSec}>
                      <input
                        value="3"
                        className={
                          Styles.paymentRadioBtn + " align-self-center"
                        }
                        type="radio"
                        onChange={() => {
                          setFieldValue("paymentStatus", 6);
                        }}
                        checked={parseInt(values.paymentStatus) === 6}
                      />
                      <label
                        onClick={() => {
                          setFieldValue("paymentStatus", 6);
                        }}
                        className={Styles.paymentLabel + " label"}
                      >
                        Send Payment Link
                      </label>
                      {values.paymentStatus === 6 ? (
                        <input
                          name="paymentLinkNo"
                          onKeyPress={(e) => {
                            if (e.key === "0" || parseInt(e.key)) {
                            } else {
                              e.preventDefault();
                            }
                          }}
                          onChange={(e) => {
                            setFieldValue("paymentLinkNo", e.target.value);
                          }}
                          type="text"
                          maxLength={10}
                          value={values.paymentLinkNo}
                          placeholder="Enter Mobile Number"
                          className={Styles.pos}
                        />
                      ) : null}
                    </div> */}
                    {touched.paymentLinkNo &&
                    errors.paymentLinkNo &&
                    values.paymentStatus === 6 ? (
                      <div
                        className={
                          Styles.errMsg + " text-danger align-self-center ps-3"
                        }
                      >
                        {errors.paymentLinkNo}
                      </div>
                    ) : null}
                    {touched.paymentStatus && errors.paymentStatus ? (
                      <div className={Styles.errMsg + " text-danger"}>
                        {errors.paymentStatus}
                      </div>
                    ) : null}
                  </div>
                ) : null}

                {values.paymentStatus === 8 ? (
                  <div>
                    <div
                      className={Styles.checkboxContainer}
                      style={{ marginLeft: "10px" }}
                    >
                      <input
                        className={Styles.ShowShippingDetail}
                        type="checkbox"
                        value={isNeedCustomerUrl}
                        checked={isNeedCustomerUrl}
                        disabled={isDisabled}
                        onChange={() =>
                          setIsNeedCustomerUrl(!isNeedCustomerUrl)
                        }
                      />
                      <label
                        className={Styles.shippingLabel + " kstoreFont ps-2"}
                      >
                        Sent Payment link SMS to Customer
                      </label>
                    </div>

                    {isNeedCustomerUrl ? (
                      <div style={{ flexDirection: "row", display: "flex" }}>
                        <div>
                          <input
                            type="text"
                            name="customer_name"
                            className={Styles.pos}
                            value={values.customer_name}
                            onChange={(e) =>
                              setFieldValue("customer_name", e.target.value)
                            }
                            placeholder="Enter Customer Name"
                          />
                          {touched.customer_name && errors.customer_name ? (
                            <div
                              className={
                                Styles.errMsg +
                                " text-danger align-self-center ps-3"
                              }
                            >
                              {errors.customer_name}
                            </div>
                          ) : null}
                        </div>
                        <div style={{ width: "48%" }}>
                          <input
                            type="text"
                            name="customer_mobile"
                            className={Styles.pos}
                            value={values.customer_mobile}
                            onChange={(e) =>
                              setFieldValue("customer_mobile", e.target.value)
                            }
                            placeholder="Enter Mobile Number"
                            onKeyPress={(e) => {
                              if (!(e.key === "0" || parseInt(e.key))) {
                                e.preventDefault();
                              }
                            }}
                            maxLength={10}
                          />

                          {touched.customer_mobile && errors.customer_mobile ? (
                            <div
                              className={
                                Styles.errMsg +
                                " text-danger align-self-center ps-3"
                              }
                            >
                              {errors.customer_mobile}
                            </div>
                          ) : null}
                        </div>
                      </div>
                    ) : null}
                  </div>
                ) : null}

                {pathname.includes("/kansas_product") && isShowShipping && (
                  <div className={Styles.inputLeftContainer}>
                    <button
                      onClick={() => {
                        if (!isErrorInAddress(false)) {
                          if (getSavedAddressesList(false).length > 0) {
                            setaddressListPopupData({
                              status: true,
                              isSave: true,
                              isBilling: false,
                            });
                          } else {
                            handleSaveUpdateAddress(false);
                          }
                        } else {
                          toast("Please enter all required shipping details.", {
                            type: "error",
                          });
                        }
                      }}
                      style={{
                        marginRight: "25px",
                        backgroundColor: isErrorInAddress(false)
                          ? "grey"
                          : "#f27f0c",
                      }}
                      className={Styles.saveAddressBtn}
                      disabled={isErrorInAddress(false)}
                    >
                      <img className={Styles.nextIcon} src={save} alt="save" />
                      Save Shipping Address
                    </button>
                  </div>
                )}

                <div className={Styles.btnContainer}>
                  <button
                    onClick={() => navigate(-1)}
                    className={Styles.cancelBtn}
                  >
                    <img className={Styles.nextIcon} src={next} alt="next" />
                    Previous
                  </button>

                  <button
                    type="submit"
                    onClick={handleSubmit}
                    className={Styles.saveBtn}
                  >
                    Next
                    <img
                      className={Styles.nextWhite}
                      src={nextWhite}
                      alt="next"
                    />
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>

        <Modal
          centered
          size="md"
          show={showModal}
          onHide={() => setShowModal(false)}
        >
          <Modal.Body>
            <div
              onClick={() => setShowModal(false)}
              className={Styles.cancelParent}
            >
              <div className={Styles.cancelContainer}>
                <img className={Styles.cancelImg} src={cancel} alt="cancel" />
              </div>
            </div>

            <div>
              <p className="label">Payment Link</p>
              <div className={Styles.PaymentInputContainer}>
                <label className="label">Mobile No</label>
                <input
                  name="paymentLinkNo"
                  onKeyPress={(e) => {
                    if (e.key === "0" || parseInt(e.key)) {
                    } else {
                      e.preventDefault();
                    }
                  }}
                  onChange={handleChange}
                  type="text"
                  maxLength={10}
                  value={values.paymentLinkNo}
                  placeholder="Enter Mobile Number"
                  className={Styles.paymentLink}
                />
              </div>
              {touched.paymentLinkNo && errors.paymentLinkNo ? (
                <div className={Styles.errMsg + " text-danger"}>
                  {errors.paymentLinkNo}
                </div>
              ) : null}
              <div className="text-end mt-2 mb-2">
                <button
                  onClick={() => {
                    if (values.paymentLinkNo === "" || errors.paymentLinkNo) {
                      setPaymentLinkError(true);
                      validateForm();
                    } else {
                      setPaymentLinkError(false);
                      setShowModal(false);
                    }
                  }}
                  className={Styles.paymentLinkBtn}
                >
                  Submit
                </button>
              </div>
            </div>
          </Modal.Body>
        </Modal>
        {addressListPopupData.status && (
          <AddressListModal
            show={addressListPopupData.status}
            onHide={() => {
              setaddressListPopupData({
                status: false,
                isSave: false,
                isBilling: false,
              });
            }}
            isBilling={addressListPopupData.isBilling}
            isSave={addressListPopupData.isSave}
            onNew={(isBilling) => {
              handleSaveUpdateAddress(isBilling);
            }}
            onUpdate={(id, isBilling) => {
              handleSaveUpdateAddress(isBilling, id);
            }}
            list={getSavedAddressesList(addressListPopupData.isBilling)}
            onRefreshAddressList={(isBilling) => {
              handleRetrieveSavedAddresses(isBilling);
            }}
            onSelectAddress={(item, isBilling) => {
              handleSelectAddress(isBilling, item);
            }}
          />
        )}
      </div>
    </div>
  );
}
